import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { getAuthToken, getAdminProfileData, setAdminProfileData } from "../utils/cookieUtils";

const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkUserRole = async () => {
      const token = getAuthToken();
      
      if (!token) {
        setLoading(false);
        return;
      }

      const adminProfileData = getAdminProfileData();
      
      if (adminProfileData && adminProfileData.message && adminProfileData.message.admin) {
        const roleId = adminProfileData.message.admin.role.id;
        setUserRole(roleId);
        setHasAccess(allowedRoles.includes(roleId));
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get("/super-admin/get-admin-profile-data", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data && response.data.message && response.data.message.admin) {
          const roleId = response.data.message.admin.role.id;
          setUserRole(roleId);
          setHasAccess(allowedRoles.includes(roleId));
          
          setAdminProfileData(response.data);
        }
      } catch (error) {
        console.error("Error fetching admin profile data:", error);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkUserRole();
  }, [allowedRoles]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <div
          className="spinner"
          style={{
            width: 40,
            height: 40,
            border: "4px solid #eee",
            borderTop: "4px solid #007bff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <p style={{ marginTop: 16, color: "#555" }}>Checking permissions...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  const token = getAuthToken();
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RoleProtectedRoute;